import { FoljaKoha, FoljaForma, FoljaVeta, FoljaNumri } from "@core/enums/folja.enum";

export class FoljaUrdherore {
  public static FoljaNumri = [
    { id: 10, short: 'nj.', long: 'njëjës' },
    { id: 11, short: 'sh.', long: 'shumës' },
  ];

  public static FoljaUrdheroreKoha = [{ id: 10, short: 'tash.', long: 'E tashme' }];

  public static FoljaUrdherorePeremri = [
    { id: 11, short: 't.', long: 'ti' },
    { id: 14, short: 'j.', long: 'ju' },
  ];

  public static FoljaVeta = [
    { id: 11, short: "v.II", long: "E dytë" },
  ]

  public static FoljaUrdheroreTrajtaTeShkurtraDhanore = [
    { id: 10, short: 'dh. I nj.', long: 'dhanore, I, njëjës' },
    { id: 11, short: 'dh. III nj.', long: 'dhanore, III, njëjës' },
    { id: 12, short: 'dh. I sh.', long: 'dhanore, I, shumës' },
    { id: 13, short: 'dh. III sh.', long: 'dhanore, III, shumës' },
  ];
  public static FoljaUrdheroreTrajtaTeShkurtraKallezore = [
    { id: 10, short: 'k. I nj.', long: 'kallëzore, I, njëjës' },
    { id: 11, short: 'k. III nj.', long: 'kallëzore, III, njëjës' },
    { id: 12, short: 'k. I sh.', long: 'kallëzore, I, shumës' },
    { id: 13, short: 'k. III sh.', long: 'kallëzore, III, shumës' },
  ];
  public static FoljaUrdheroreTrajtaTeShkurtraTeBashkuara = [
    { id: 10, short: 'dh. I njk. III nj.', long: 'dhanore, I, njëjës+kallëzore, III, njëjës' },
    { id: 11, short: 'dh. I njk. III sh.', long: 'dhanore, I, njëjës+kallëzore, III, shumës' },
    { id: 12, short: 'dh. I shk. III nj.', long: 'dhanore, I, shumës+kallëzore, III, njëjës' },
    { id: 13, short: 'dh. I shk. III sh.', long: 'dhanore, I, shumës+kallëzore, III, shumës' },
    { id: 14, short: 'dh. III njk. III nj.', long: 'dhanore, III, njëjës+kallëzore, III, njëjës' },
    { id: 15, short: 'dh. III njk. III sh.', long: 'dhanore, III, njëjës+kallëzore, III, shumës' },
    { id: 16, short: 'dh. III shk. III nj.', long: 'dhanore, III, shumës+kallëzore, III, njëjes' },
    { id: 17, short: 'dh. III shk. III sh.', long: 'dhanore, III, shumës+kallëzore, III, shumës' },
  ];


  public static Structure: { kohaId: number; formaId: number; vetaId: number; numriId: number; left?: string; }[] = [
    { kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, left: 'ti', },
    { kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Njejes, left: 'ti', },
    { kohaId: FoljaKoha.ETashme, formaId: FoljaForma.Veprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, left: 'ju', },
    { kohaId: FoljaKoha.ETashme, formaId: FoljaForma.JoVeprore, vetaId: FoljaVeta.Edyte, numriId: FoljaNumri.Shumes, left: 'ju', },
  ];
}
